module.exports = __webpack_public_path__ + "img/consultYou2.ae2265ad.png";